module.exports = __webpack_public_path__ + "assets/b3838ae746e2f74f777693595f6f873a.mp3";